module.exports = __webpack_public_path__ + "img/oaknest-3.03faaeaf.jpeg";